new Swiper(".js-lastnews-slider", {
  slidesPerView: 1.2,
  spaceBetween: 24,
  loop: true,
  centeredSlides: false,
  speed: 500,
  scrollbar: {
    el: ".swiper-scrollbar",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1.2,
      spaceBetween: 16,
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 2.2,
    },
    768: {
      slidesPerView: 3.2,
    },
    // when window width is >= 640px
    1100: {
      slidesPerView: 4.2,
      spaceBetween: 24,
    },
  },
});

// new Swiper(".js-weprovide-slider", {
//   slidesPerView: 1.2,
//   spaceBetween: 24,
//   loop: false,
//   centeredSlides: false,
//   speed: 500,
//   scrollbar: {
//     el: ".swiper-scrollbar",
//   },
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   breakpoints: {
//     // when window width is >= 320px
//     320: {
//       slidesPerView: 1.2,
//       spaceBetween: 16,
//       loop: false,
//     },
//     // when window width is >= 480px
//     600: {
//       slidesPerView: 2.2,
//       loop: false,
//     },
//     768: {
//       slidesPerView: 3.2,
//       loop: false,
//     },
//     // when window width is >= 640px
//     1100: {
//       slidesPerView: 4.2,
//       spaceBetween: 24,
//       loop: false,
//     },
//   },
// });

var homeSwiper4 = new Swiper(".homeSwiper4", {
  // slidesPerView: 4.1,
  // spaceBetween: 24,
  // loop: true,
  // centeredSlides: true,
  speed: 500,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  breakpoints: {
    320: {
      slidesPerView: 1.4,
      spaceBetween: 16,
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    992: {
      slidesPerView: 4.1,
      spaceBetween: 24,
    },
  },
});

const setActiveAccordionItem = (index) => {
  const jsListItems = document.querySelectorAll(".js-list-item");
  const jsListImageInners = document.querySelectorAll(
    ".js-list-image-inner"
  );

  if (jsListItems.length) {
    for (let i = 0; i < jsListItems.length; i++) {
      jsListItems[i]
        .querySelector(".js-list-data")
        .classList.remove("active");
      jsListItems[i]
        .querySelector(".js-list-btn")
        .classList.remove("active");
    }

    jsListItems[index]
      .querySelector(".js-list-data")
      .classList.add("active");
    jsListItems[index]
      .querySelector(".js-list-btn")
      .classList.add("active");

    jsListImageInners.forEach((image) => {
      image.style.display = "none";
    });

    jsListImageInners[index].style.display = "block";
  }
};

const jsList = document.querySelector(".js-list");
const jsListBtns = jsList?.querySelectorAll(".js-list-btn");

if (jsList) {
  const jsListItemsLength = jsList.querySelectorAll(".js-list-item").length;

  if (jsListItemsLength) {
    let j = 0;

    const intervalId = setInterval(() => {
      setActiveAccordionItem(j);
      if (j < jsListItemsLength - 1) {
        j += 1;
      } else {
        j = 0;
      }
    }, 3000);

    if (jsListBtns.length) {
      for (let i = 0; i < jsListBtns.length; i++) {
        jsListBtns[i].addEventListener("click", (e) => {
          setActiveAccordionItem(i);
          j = i;
          clearInterval(intervalId);
        });
      }
    }
  }
}

const accordionLoopList = document.querySelectorAll(".js-accordion-loop");

if (accordionLoopList.length) {
  for (let i = 0; i < accordionLoopList.length; i++) {
    const btn = accordionLoopList[i].querySelector(
      ".js-accordion-loop-btn"
    );
    if (btn) {
      btn.addEventListener("click", (e) => {
        const accordionLoopContent = e.currentTarget
          .closest(".js-accordion-loop")
          .querySelector(".js-accordion-loop-content");

        const accordionLoopBtn = e.currentTarget
          .closest(".js-accordion-loop")
          .querySelector(".js-accordion-loop-btn");

        const height = accordionLoopContent.scrollHeight;

        if (accordionLoopContent.classList.contains("active")) {
          // close current item START
          accordionLoopContent.classList.remove("active");
          accordionLoopBtn.classList.remove("active");
          accordionLoopContent.classList.remove("fadeIn");
          accordionLoopContent.style.maxHeight = "0px";
          // close current item END
        } else {
          // close all items START
          accordionLoopList.forEach((item) => {
            const accordionLoopContent = item.querySelector(
              ".js-accordion-loop-content"
            );
            const accordionLoopBtn = item.querySelector(
              ".js-accordion-loop-btn"
            );

            accordionLoopContent.classList.remove("active");
            accordionLoopBtn.classList.remove("active");
            accordionLoopContent.classList.remove("fadeIn");
            accordionLoopContent.style.maxHeight = "0px";
          });
          // close all items END

          // open current item START
          accordionLoopContent.classList.add("active");
          accordionLoopBtn.classList.add("active");
          accordionLoopContent.classList.add("fadeIn");
          accordionLoopContent.style.maxHeight = `${height}px`;
          // open current item END
        }
      });
    }
  }
}

(function ($) {
  //console.log("test");

  $(document).on("ready", function () {
   
  });

  // initVHunits();
  // $(document).on('ready', function () {
  //     initVideoPopups();
  // });
  // $(window).on('resize', function () {
  //     initVHunits();
  // });
  // function initVHunits() {
  //     let vh = window.innerHeight * 0.01;
  //     let win_height = window.innerHeight;
  //     document.documentElement.style.setProperty('--vh', `${vh}px`);
  //     document.documentElement.style.setProperty('--win_h', `${win_height}px`);
  // }
  // function initVideoPopups() {
  //     //move modal to body
  //     //$('#videoModal').appendTo('body');
  //     var $videoSrc;
  //     $('.lazy-load-video').on('click', function (e) {
  //         let iframe_src = $(this).attr('data-embed');
  //         if (iframe_src) {
  //             $videoSrc = iframe_src + "&autoplay=1";
  //         }
  //     });
  //     // when the modal is opened autoplay it
  //     $(document).on('shown.bs.modal', '#videoModal', function (e) {
  //         // set the video src to autoplay and not to show related video. Youtube related video is like a box of chocolates... you never know what you're gonna get
  //         $("#video").attr('src', $videoSrc);
  //     })
  //     // stop playing the youtube video when I close the modal
  //     $('#videoModal').on('hide.bs.modal', function (e) {
  //         // a poor man's stop video
  //         $("#video").attr('src', '');
  //     })
  // }
})(jQuery);
